import { RESPONSIVE_PANEL_MOBILE_BREAKPOINT } from '../hooks/useResponsivePanelPlacement';

/** Matches the layout switch to the desktop sidebar (`lg`). */
export const DESKTOP_MEDIA_QUERY = '(min-width: 1024px)';

/** Matches Tailwind's `sm` breakpoint: past a phone's width. */
export const SM_MEDIA_QUERY = `(min-width: ${RESPONSIVE_PANEL_MOBILE_BREAKPOINT}px)`;

/** Whether the desktop layout is showing, read once at call time rather than kept current. */
export function isDesktopViewport(): boolean {
  return window.matchMedia(DESKTOP_MEDIA_QUERY).matches;
}
